
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartNationalLanguageProposal1 as ObiChartNationalLanguageProposal1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-national-language-proposal-1.js';
 
 
 

 
 export const ObiChartNationalLanguageProposal1 = createComponent({
   react: React,
   tagName: 'obi-chart-national-language-proposal-1',
   elementClass: ObiChartNationalLanguageProposal1Element,
   events: {
     
   }
  });
 
 